import { useStore } from 'vuex';
import { useActions, useState } from "@/utils/map-state";
import { promoteUrl } from "@/utils/url";
export default {
  name: "loginBoxPC",
  setup() {
    const store = useStore();
    const commonState = useState("common", ["loginBox"]);
    let {
      loginBox
    } = commonState;
    const commonActions = useActions("common", ["clearLoginBox"]);
    const close = () => {
      commonActions.clearLoginBox({});
    };
    const gotoLogin = method => {
      // 因为怕有延迟，所以添加 loading 来防呆
      store.dispatch("common/handleLoading", true);
      store.dispatch("common/closeRedirectLoadingInterval");
      window.location.href = promoteUrl() + "/member_vue.php?platform=2&method=" + (method === "reg" ? method : "login");
    };
    const buttonMethodText = method => {
      return method === "reg" ? "注册" : "登录";
    };
    return {
      buttonMethodText,
      gotoLogin,
      loginBox,
      close
    };
  }
};